import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AdditionalServicesActionCreator, AppointmentActionCreator, FrameworkActionCreator, RepairOrdersActionCreator, ROHistoryActionCreator, VehiclesActionCreator } from 'src/store/states';
import OpenRepairSelect from '../OpenRepairSelect';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    repairOrders: state.RepairOrders,
    customer: state.Customer.Customer!,
    vehicles: state.Vehicles,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    locale: state.Framework.locale,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    selectRO: RepairOrdersActionCreator.SelectRO,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    getROHistory: ROHistoryActionCreator.GetROHistory,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    updateApptVeh: AppointmentActionCreator.UpdateApptVehicle,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OpenRepairSelect);